/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockPage } from '@staffino/model';
import { Box, styled, Theme } from '@staffino/primitive-controls';
import useObjects from '../use-objects-hook';
import BlockFactory from './block-factory';
import FlowRestartBlock from './flow-restart-block';

const FooterContainer = styled(Box)((props: { theme?: Theme }) => ({
  backgroundColor: props.theme.colors.background,
  padding: '0.5rem 1rem 1.5rem',
  '&:empty': {
    display: 'none',
  },
}));

type Props = {
  block: FlowBlockPage;
};
const PageBlock = ({ block: { children = [] } }: Props) => {
  const [settings] = useObjects('flow-settings');
  const headerChildren = children.filter((child) => child.region === 'header');
  const footerChildren = children.filter((child) => child.region === 'footer');
  const centerChildren = children.filter(
    (child) => child.region !== 'header' && child.region !== 'footer',
  );
  const needsRestartBlock =
    !children.find((ch) => ch.type === 'flow-restart') &&
    settings?.pageTimeout > 0;

  return (
    <Box height="100%">
      <Box flex={0} className="header" minHeight="auto">
        {headerChildren.map((child) => (
          <BlockFactory key={child.id} block={child} />
        ))}
      </Box>
      <Box flex={1} justifyContent="center">
        {centerChildren.map((child) => (
          <BlockFactory key={child.id} block={child} />
        ))}
      </Box>
      <FooterContainer flex={0} className="footer">
        {footerChildren.map((child) => (
          <BlockFactory key={child.id} block={child} />
        ))}
      </FooterContainer>
      {needsRestartBlock && (
        <FlowRestartBlock
          block={{
            id: 'flow-restart' as const,
            type: 'flow-restart' as const,
            restartTime: settings?.pageTimeout ?? 5,
          }}
        />
      )}
    </Box>
  );
};

export default PageBlock;
